import { request } from '@/utils/request';

export const fetchNotificationPreferences = async () => (await request.get('/notifications/preferences/')).data;
export const updateNotificationPreferences = async data => (await request.patch('/notifications/preferences/', data)).data;

export const fetchNotifications = async (params = {}) => (await request.get('/notifications/', { params })).data;
export const fetchNotificationSummary = async () => (await request.get('/notifications/unread-count/')).data;
export const readNotification = async id => (await request.post(`/notifications/${id}/read/`)).data;
export const readAllNotifications = async upToId => (await request.post('/notifications/read-all/', { up_to_id: upToId })).data;
